import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function Hero3({data}) {
    const {hero3Text, hero3Title, hero3Image} = data
    return (
        <div className='inner-banner gradient-hero font-white'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-6'>
                        <h1 className='heading-level-1'>{hero3Title && parser(hero3Title)}</h1>
                        {hero3Text && parser(hero3Text)}
                    </div>
                    <div className='col-md-6'>
                        <div className='dana-profile-hero'>
                            <GatsbyImage
                                image={getImage(hero3Image?.localFile)}
                                alt='image'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
